import React, {useState, useRef, useCallback} from 'react';
import useBookSearch from "./useBookSearch";
import {Avatar, Button, Card, CardActionArea, CardContent, CardHeader} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useForm} from "react-hook-form";
import {autocompleteRules} from "../../../../utils/RegisterUtils";
import {CustomAutoComplete} from "../../../widgets/inputs/CustomAutoComplete";

export const Test = () => {
		const classes = BaseStyle();
		const [query, setQuery] = useState("")
		const [pageNumber, setPageNumber] = useState(1)
		const {books, loading, error, hasMore} = useBookSearch(query, pageNumber);
		const {control, errors, handleSubmit} = useForm({mode: "onChange"});
		
		const onSubmit = useCallback((data) => {
			alert(JSON.stringify(data));
		}, [])
		
		const observer = useRef();
		
		const lastBookElementRef = useCallback(node => {
			if (loading) return
			if (observer.current) observer.current.disconnect()
			observer.current = new IntersectionObserver(entries => {
				if (entries[0].isIntersecting && hasMore) {
					console.log("Visible")
					setPageNumber(prevState => prevState + 1)
				}
			})
			if (node) observer.current.observe(node)
			console.log(node);
		}, [loading, hasMore])
		
		const handleSearch = (e) => {
			setQuery(e.target.value);
			setPageNumber(1)
		}
		
		
		return (
			<React.Fragment>
				<form onSubmit={handleSubmit(onSubmit)} style={{margin: 30}}>
					<CustomAutoComplete
						label={"test"}
						control={control}
						options={["ciao", "test"]}
						multiple={true}
						rules={autocompleteRules}
						name={"regioniVisitate"}
						error={errors["regioniVisitate"]}
					/>
					<Button type={"submit"}>
						Submit
					</Button>
				</form>
				<input type={"text"} value={query} onChange={handleSearch}/>
				{books.map((book, index) => {
					if (books.length === index + 1) {
						return (
							<Card ref={lastBookElementRef} key={book} className={classes.roundCard} style={{backgroundColor: "red"}}>
								<CardActionArea>
									<CardHeader
										avatar={
											<Avatar>#</Avatar>
										}
										title={book}
										subheader={"subheader..."}
									/>
									<CardContent>
										content of the card...
									</CardContent>
								</CardActionArea>
							</Card>
						)
					} else {
						return (
							<Card key={book} className={classes.roundCard}>
								<CardActionArea>
									<CardHeader
										avatar={
											<Avatar>#</Avatar>
										}
										title={book}
										subheader={"subheader..."}
									/>
									<CardContent>
										content of the card...
									</CardContent>
								</CardActionArea>
							</Card>
						)
					}
				})}
				{loading && <div>Loading...</div>}
				{error && <div>Error...</div>}
			</React.Fragment>
		);
	}
;
